import { useState, useEffect, useContext } from 'react'
import { useHistory  } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Message from '@material-ui/icons/Message'
import { IconButton, Menu, MenuItem, Typography, Divider, Avatar, Badge } from '@material-ui/core'
import { StateContext } from 'context/Provider'

import axios from 'axios'
import Moment from 'moment'

import './style.css'

const Messages = () => {
  const history = useHistory()
  const appState = useContext(StateContext)
  const { authState } = appState

  const [anchorEl, setAnchorEl] = useState(null)
  const [notificationCount, setMessagesCount] = useState(0)
  const [messages, setMessages] = useState([])

  const getMessages = async () => {
    const axiosInstance = axios.create({
      baseURL: 'https://sms.academeportal.com/api/'
    });

    const response = await axiosInstance.get(`messages/${authState.user.id}`)

    if (response.data) {
      let unReadMessages = response.data.filter((msg) => {
        return msg.is_read === 0
      })
      setMessagesCount(unReadMessages.length)
      setMessages(response.data)
    }
  }

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = (event) => {
    setAnchorEl(null)
  }

  const messageTime = (date) => {
    let momentDdate = Moment(date)
    let relativeTime = momentDdate.startOf('hour').fromNow()
    if (relativeTime.includes('minutes' || relativeTime.includes('hours')) || relativeTime.includes('hour')) {
      return relativeTime
    }

    return momentDdate.format('MMMM D, YYYY hh:mm a')
  }

  useEffect(() => {
    getMessages()
  }, [])

  return (
    <>
      <IconButton
        aria-controls="notifications"
        aria-haspopup="true"
        color="inherit"
        onClick={openMenu}
      >
        <Badge badgeContent={notificationCount} color="primary">
          <Message />
        </Badge>
      </IconButton>

      <Menu
        id="notifications"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        style={{minWidth: '500px'}}
      >
        {messages.length > 0 && messages.slice(0, 5).map((msg) => (
            <Link to={`/message/${msg.message_id}`} 
              onClick={() => closeMenu()} 
              style={{textDecoration: 'none', color: 'black'}} 
              key={msg.message_id}
            >
              <MenuItem dense>
                <Avatar alt={msg.sender} src="/static/images/avatar/1.jpg" />
                <div style={{marginLeft: '15px', whiteSpace: 'initial', textOverflow: 'ellipsis', flexGrow: '1'}}>
                  <Typography variant="subtitle2">{msg.subject}</Typography>
                  <Typography className='notification-description' variant="body1" dangerouslySetInnerHTML={{__html: msg.body}} />
                  <Typography variant="caption">{msg.sender} - {messageTime(msg.created_at)}</Typography>
                </div>
                <div>
                  {msg.is_read === 0 &&
                    <Badge id="unread-badge" badgeContent='' color="primary">
                    </Badge>
                  }
                </div>
              </MenuItem>
              <Divider />
            </Link>
          ))
        }
        {messages.length > 0 &&
          <Link
            onClick={() => {
              history.push('/message/all')
              closeMenu()
            }}
            style={{display: 'block', textAlign: 'center', textDecoration: 'none', padding: '10px', paddingBottom: '5px'}}
          >
            <span>View All Messages</span>
          </Link>
        }
        {messages.length === 0 &&
          <Link style={{display: 'block', textAlign: 'center', textDecoration: 'none', padding: '10px', paddingBottom: '5px'}}>
            <span>No Messages</span>
          </Link>
        }
      </Menu>
    </>
  )
}

export default Messages